import React, { useEffect, useState } from "react";
import Constant from "../../../../utils/constant";
import { IPermission } from "../../../../model/interface/permission";
import { IBreadcrumb } from "../../../../model/interface/breadcrumb";
import { Link } from "react-router";
import { useForm } from "react-hook-form";
import Breadcrumb from "../../../shared/common/breadcrumb";
import {
  createPermission,
  updatePermission,
  getPermissionById,
} from "../../../../api/permission.service";
import Loader from "../../../shared/loader/loader";
import AllowedTo from "../../../shared/common/rbac";
import pagePermissions from "../../../../utils/permissions";
import AccessDenied from "../../../shared/common/accessDenied";
import { useNumericParam } from "../../../../utils/useNumericParam";

function ManageTag() {
  const id = useNumericParam("id");
  const [name, setName] = useState<string>("");
  const [description, setDescription] = useState<string>("");
  const [loading, setLoading] = useState<boolean>(false);

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const onSubmit = async (data) => {
    const module = await import("react-toastify");
    const permissionData: IPermission = {
      permissionId: id ? id : 0,
      name: data.name.toLowerCase(),
      description: data.description,
    };
    setLoading(true);
    if (id) {
      updatePermission(permissionData).then((res) => {
        setLoading(false);
        if (res.data === -1) {
          module.toast.warning("Please use unique permission name");
        } else if (res.data >= 0) {
          module.toast.success("Permission saved");
        }
      });
    } else {
      createPermission(permissionData).then((res) => {
        setLoading(false);
        if (res.data === -1) {
          module.toast.warning("Please use unique permission name");
        } else if (res.data >= 0) {
          module.toast.success("Permission saved");
        }
      });
    }
  };

  const getPermissionForEdit = (permissionId: number) => {
    setLoading(true);
    getPermissionById(permissionId).then((res) => {
      setName(res.data.name);
      setDescription(res.data.description);
      setLoading(false);
    });
  };

  useEffect(() => {
    if (id) getPermissionForEdit(id);
  }, []);

  const breadcrumbItems = () => {
    const items: Array<IBreadcrumb> = [
      { name: "Permission", url: Constant.PERMISSIONS },
      {
        name: id ? "Edit Permission" : "Add Permission",
        url: "",
      },
    ];

    if (id) {
      items.push({
        name: "",
        url: "",
        objectId: id?.toString(),
      });
    }

    return items;
  };

  return (
    <AllowedTo
      perform={[
        pagePermissions.permissions_create,
        pagePermissions.permissions_modify,
      ]}
      no={() => <AccessDenied />}
    >
      <div className="flex-1 overflow-auto">
        {loading && <Loader />}
        <div className=" h-auto min-h-half rounded-bl-3xl bg-site-teal px-8  py-8 pt-0 pb-14 overflow-y-auto mt-7 ">
          <div className="relative  py-1">
            <div className="overlay-image-main pointer-events-none fixed left-0 top-0 w-screen h-screen z-20"></div>
            <div className="flex items-center justify-between">
              <h3 className="text-lg font-light text-gray-900">
                {id ? "Edit Permission " : "Add Permission "}
              </h3>
            </div>
            <Breadcrumb items={breadcrumbItems()} />
            <form onSubmit={handleSubmit(onSubmit)}>
              <div className="shadow border  border-gray-300 rounded-md mt-4 px-4 py-6 w-1/4">
                <div>
                  <div className="grid grid-cols-1">
                    <div className="text-sm">
                      <label className="font-medium text-gray-700">Name</label>
                    </div>
                    <div className="mt-1 text-sm">
                      <input
                        type="text"
                        defaultValue={name}
                        autoFocus={true}
                        autoComplete="off"
                        className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-primary-color focus:border-primary-color dark:focus:border-gray-500 dark:focus:ring-gray-500 dark:bg-custom-black dark:text-white sm:text-sm"
                        {...register("name", {
                          required: true,
                          pattern: {
                            value: /^[a-z_]*$/,
                            message: "Please enter a valid email",
                          },
                        })}
                      />
                      {errors.name &&
                        (typeof errors.name?.message === "string"
                          ? errors.name.message.length
                          : 0) === 0 && (
                          <span className="text-red-700 inline-block pt-1 text-sm">
                            Name is required.
                          </span>
                        )}

                      {typeof errors.name?.message === "string" &&
                        errors.name.message.length > 0 && (
                          <span className="text-red-700 inline-block pt-1 text-sm">
                            Allowed characters: a-z, _
                          </span>
                        )}
                    </div>
                  </div>

                  <div className="grid grid-cols-1 mt-5">
                    <div className="text-sm">
                      <label className="font-medium text-gray-700">
                        {" "}
                        Description
                      </label>
                    </div>
                    <div>
                      <textarea
                        style={{
                          minHeight: "150px",
                        }}
                        defaultValue={description}
                        autoComplete="off"
                        className="block w-full mt-1 border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-primary-color focus:border-primary-color dark:focus:border-gray-500 dark:focus:ring-gray-500 dark:bg-custom-black dark:text-white sm:text-sm"
                        {...register("description", {
                          required: false,
                        })}
                      />
                    </div>
                  </div>

                  <div className="flex justify-end mt-8 items-center border-t ">
                    <button className="inline-flex items-center px-3 py-2 my-3 hover:bg-secondary-color border border-transparent text-sm leading-4 font-medium rounded-md shadow-sm text-white dark:text-white bg-primary-color  focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-color">
                      {id ? "Update " : "Save"}
                    </button>
                    <Link to={Constant.PERMISSIONS} className="ml-2">
                      <button className="inline-flex items-center px-3 py-2 my-3 hover:text-gray-500 border border-gray-300 text-sm leading-4 font-medium rounded-md shadow-sm text-gray-700 bg-white  focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-color">
                        Cancel
                      </button>
                    </Link>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </AllowedTo>
  );
}

export default ManageTag;
